import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { LocationRelatedDTO } from '../../locations-map/models/LocationRelatedDTO';
@Injectable({
    providedIn: 'root'
  })


export class SwalNotificationService {

  public systemNotification: string = "";

  constructor(){
  }

  confirmMessage(title, message) {
      return Swal.fire({
        title: title,
        text: message,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Si',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      });
  }

    message(text) {
      Swal.fire(text);
    }
  
    MessageSuccessful(title, text) {
      Swal.fire(title, text, "success");
    }
  
    MessageError(text) {
      Swal.fire("Algo salió mal", text, "error");
    }

    MessageInfo(text) {
      Swal.fire("Información", text, "info");
    }
  
    MessageDownloading(){
      return Swal.fire({
            title: 'Solicitud de Reporte en curso',
            text: 'El reporte está siendo procesado sin embargo éste proceso puede demorar unos minutos, le informaremos cuando esté listo',// add html attribute if you want or remove
            allowOutsideClick: false,
        });
    }
  
    MessageDetails(detailList: string[]) {
      let message = '<ul style="list-style-type: none; padding-left: 0;">'; // Comienza una lista HTML y quita los estilos por defecto
      
      // Itera sobre cada detalle y los agrega como elementos de lista
      detailList.forEach((detail, index) => {
        // Aplica estilos de tabla a cada elemento de lista
        message += `<li style="border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; padding: 5px 0;">${detail}</li>`;
      });
      
      message += '</ul>';
      
      return Swal.fire({
        title: 'El usuario ha realizado las siguientes acciones',
        html: message, 
        allowOutsideClick: false,
      });
    }

    MessageDetailsAsTable(detailsObjt: any) {
      let message = '<table style="border-collapse: collapse; width: 100%;">'; 
      
      // Llaves
      message += '<tr style="background-color: #f2f2f2;">';
      Object.keys(detailsObjt).forEach(key => {
        message += `<th style="border: 1px solid #ddd; padding: 2px; font-size: small; min-width: 70px;">${key}</th>`;
      });
      message += '</tr>';
      
      // Valores
      message += '<tr>';
      Object.values(detailsObjt).forEach(value => {
        message += `
          <td style="border: 1px solid #ddd; padding: 0px; font-size: x-small; max-width: 180px; height: 100px;">
            <div style="max-height: 100px; overflow-y: auto;">${value}</div>
          </td>`;
      });
      message += '</tr>';
      
      message += '</table>';
      
      return Swal.fire({
        title: 'Datos del log',
        html: message,
        width: '90%',
        allowOutsideClick: true,
      });
    }
    
  
    LocationsRelatedDetails(LocationRelated: LocationRelatedDTO) {
      let message = "";
    
      return Swal.fire({
        title: 'Detalles de ubicación',
        html: `
          <div class="popup-content">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque aliquid, amet eum nihil sunt alias eligendi.</p>
            <div class="address">
              <strong>Dirección:</strong>
              <p>Dirección de la ubicación</p>
            </div>
          </div>
        `,
        allowOutsideClick: false,
        confirmButtonColor: '#007bff',
        confirmButtonText: 'Aceptar',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'Cancelar'
      });
    }
}
